import { useMemo } from 'react'

import { OrgByParent } from 'api/types/orgsApiTypes'
import { useOrg } from 'contexts/OrgContext'
import { useOrgsByParent } from 'hooks/data/orgsHook'

export const useIsTopLevelOrg = () => {
  const { data, isLoading } = useOrgsByParent()
  const { org } = useOrg()

  const isParentOrg = useMemo(() => {
    if (!data || !org) {
      return false
    }

    return data.some((entry: OrgByParent) => [entry.org_name, entry.org_display_name].includes(org))
  }, [data, org])

  return {
    isParentOrg,
    isLoading,
  }
}
